import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-notification-permission-dialog',
  template: `
    <h2 mat-dialog-title>
      <mat-icon class="notif-title-icon">notifications_off</mat-icon>
      {{ 'shared_notif_enable_title' | translate }}
    </h2>
    <mat-dialog-content>
      <p>{{ 'shared_notif_enable_subtitle' | translate }}</p>
      <div style="margin: 16px 0; padding: 16px; background-color: #f5f5f5; border-radius: 4px;">
        <strong>{{ 'shared_notif_instructions_for' | translate }} {{ data.browserName }}:</strong>
        <ol class="notif-instructions-list" style="margin: 8px 0 0 0; padding-left: 20px;">
          <li *ngFor="let step of data.instructions">{{ step }}</li>
        </ol>
      </div>
      <p style="margin-top: 16px; font-size: 0.9em; color: #666;">
        {{ 'shared_notif_try_again_hint' | translate }}
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">{{ 'shared_notif_maybe_later' | translate }}</button>
      <button mat-button [mat-dialog-close]="true" color="primary">
        <mat-icon class="notif-action-icon">refresh</mat-icon>
        {{ 'shared_notif_try_again' | translate }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      min-width: 400px;
    }
    ol {
      line-height: 1.8;
    }
    .notif-title-icon {
      vertical-align: middle;
      margin-right: 8px;
    }
    .notif-action-icon {
      vertical-align: middle;
      margin-right: 4px;
    }
    :host-context([dir="rtl"]) .notif-title-icon {
      margin-right: 0;
      margin-left: 8px;
    }
    :host-context([dir="rtl"]) .notif-action-icon {
      margin-right: 0;
      margin-left: 4px;
    }
    :host-context([dir="rtl"]) .notif-instructions-list {
      padding-left: 0 !important;
      padding-right: 20px;
    }
  `]
})
export class NotificationPermissionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NotificationPermissionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      browserName: string;
      instructions: string[];
    }
  ) {}
}

